export const GoogleMapApiConfig = 'AIzaSyCw1RDlZpNk31Km-o4C6v-Cia7LStg_hoA';